import { render, staticRenderFns } from "./TekaComponent.vue?vue&type=template&id=0ec1efa0&xmlns=true&"
import script from "./TekaComponent.vue?vue&type=script&lang=js&"
export * from "./TekaComponent.vue?vue&type=script&lang=js&"
import style0 from "./TekaComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports